import { Typography } from 'antd';
import MyTable from './MyTable';
import endPoints from '../../../shared/endPoints/EndPoints.json';
import { colors } from '../../../shared/styles/baseStyle';
import HomeCard from '../HomeCard';

export default function ContractTripsResults() {
  const { Text } = Typography;
  const endPoint = endPoints.CONTRACT.CONTRACTTRIPS;

  const columns = [
    {
      title: 'ΕΝΑΡΞΗ',
      dataIndex: 'startDate',
      key: 'startDate'
    },
    {
      title: 'ΛΗΞΗ',
      dataIndex: 'endDate',
      key: 'endDate'
    },
    {
      title: 'ΧΛΜ',
      dataIndex: 'kilometers',
      key: 'kilometers',
      render: val => <Text style={{ color: colors.anytimeViolet }}>{val}</Text>
    }
  ];

  return (
    <HomeCard title="Διαδρομές">
      <MyTable endPoint={endPoint} columns={columns} size="small" />
    </HomeCard>
  );
}
